import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE,
} from '../actions/actionTypes';
import { getconsignmentAddCategoryAndBrandsDataService } from '../../services';
import { updateIsAllTerritoryId } from 'src/utils/util';

export default function* getconsignmentAddCategoryAndBrands() {
    try {
        const { territoryId } = yield select((state) => ({
            territoryId: state.consignmentAddReducer.consignmentAddDetails.territoryId
        }));
        const territoryIdValue =  updateIsAllTerritoryId(territoryId);
        const result = yield getconsignmentAddCategoryAndBrandsDataService(encodeURIComponent(territoryIdValue));
        const updatedData = result?.brandData?.map((item) => {
            return {
                ...item,
                isChecked: false,
            };
        });
        result.brandData = updatedData;
        yield put({
            type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS,
            categoryAndBrands: result,
        });
    } catch (e) {
        const { territoryId } = yield select((state) => ({
            territoryId: state.consignmentAddReducer.consignmentAddDetails.territoryId
        }));
        const territoryIdValue = updateIsAllTerritoryId(territoryId);
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/products/productBrandAndCategoryList?orderType=KB&territoryId=${encodeURIComponent(territoryIdValue)}`,
            requestPayload: { territoryId: territoryIdValue }
        });
        yield put({
            type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
